import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

export default function BrandCard({ brand }) {
  // Handle brands with missing data gracefully for mockups
  const websiteRaw = brand.website_url || brand.website || '';
  const website = websiteRaw
    ? (websiteRaw.startsWith('http') ? websiteRaw : `https://${websiteRaw}`)
    : '';
  const insightsCount = brand.insights || 0;
  const descriptor = brand.descriptor || 'No description available.';
  const slug = brand.slug || '#';

  return (
    <div className="p-6 rounded-xl bg-surface border border-white/5 hover:border-white/20 transition-all group h-full flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center font-bold text-sm text-white">
            {brand.name.substring(0, 2).toUpperCase()}
          </div>
          <div>
            <h4 className="font-bold text-white text-lg leading-none">{brand.name}</h4>
            <span className="text-xs text-slate-500">{insightsCount} insights contributed</span>
          </div>
        </div>
      </div>
      <p className="text-sm text-slate-400 mb-6 leading-relaxed flex-grow">{descriptor}</p>
      
      <div className="flex items-center gap-3 pt-4 border-t border-white/5 mt-auto">
        {website && (
          <a href={website} target="_blank" rel="noopener noreferrer" className="flex-1 py-2 text-center bg-gradient-primary text-white hover:scale-105 shadow-glow-blue rounded-lg text-sm font-bold transition-all flex items-center justify-center gap-2">
              Visit Website
              <ExternalLink className="w-4 h-4" />
          </a>
        )}
        <Link to={`/brands/${slug}`} className="flex-1 py-2 text-center border border-white/10 text-slate-400 hover:text-white hover:border-white/30 rounded-lg text-sm font-medium transition-colors">
            View on PodVault
        </Link>
      </div>
    </div>
  );
}
